import { ArrowRightIcon } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { observable, runInAction } from 'mobx'
import { observer } from 'mobx-react-lite'

import { env } from '@campai/lib-web/env'
import { BrandLogo } from '@campai/lib-web/components'
import { Field, FieldError, FieldLabel, Input } from '@campai/lib-web/components/new/ui'

import { Button } from './Button'
import { CreateOrganizationInput, Step } from './types'

const Element = observer(
    ({ input: { organization, ui }, onNext }: { input: CreateOrganizationInput; onNext: undefined | (() => void) }) => {
        const { t } = useTranslation()

        const i18nKey = 'createOrganization.welcome'

        return (
            <div>
                <BrandLogo className="mb-6 h-8 w-auto" />
                <div className="mb-2 text-xl font-medium">
                    {t(`${i18nKey}.title`, { productName: env.VITE_PRODUCT_NAME })}
                </div>
                <div className="mb-6 text-base leading-7 text-neutral-600">{t(`${i18nKey}.description`)}</div>
                <Field className="mb-4">
                    <FieldLabel className="mb-2">{t(`${i18nKey}.nameLabel`)}</FieldLabel>
                    <Input
                        aria-invalid={!!ui.validationErrors?.getError('organization.name')}
                        placeholder={t(`${i18nKey}.namePlaceholder`)}
                        value={organization.name}
                        onChange={(event) => runInAction(() => (organization.name = event.target.value))}
                    />
                    <FieldError>{ui.validationErrors?.getError('organization.name')}</FieldError>
                </Field>
                <div className="mt-6 flex justify-center">
                    <Button
                        disabled={!onNext}
                        icon={<ArrowRightIcon className="size-4" />}
                        mode="label"
                        onClick={onNext ?? undefined}
                    >
                        {t(`${i18nKey}.start`)}
                    </Button>
                </div>
            </div>
        )
    }
)

export const createWelcome = (input: CreateOrganizationInput): Step =>
    observable({
        id: 'welcome',
        Element,
        get isAvailable() {
            return true
        },
        get isValid() {
            return input.organization.name.length > 3
        },
    })
